// extracted by mini-css-extract-plugin
export var button = "_ds-7";
export var buttonRow = "_ds-6";
export var fadeIn = "_ds-1";
export var gradient = "_ds-0";
export var panel = "_ds-2";
export var panelIn = "_ds-3";
export var subtitle = "_ds-5";
export var title = "_ds-4";